<template>
  <div :style="{
    display: $store.state.app.submit_form_isShow  ? 'block': 'none'
  }" class="dialog_wrap">
    <div class="dialog_layout"></div>
    <div class="dialog_container">
      <!--popup_tool_tab-->
      <div class="popup_tool_tab" v-if="tool_tab_isShow">
        <div class="tool_btn eidt_tool" @click="openEditFormDialog">
          <i class="btn_icon"></i>
          <span class="btn_text">{{$t('components_basic_addarticle_index_2003')}}</span>
        </div>
        <div class="tool_btn_split"></div>
        <!-- $store.state.app.manageFormURL $store.getters['app/form_list_link']  -->
        <a target="_blank" :href="$store.getters['app/form_list_link'] " class="tool_btn manage_tool">
          <i class="btn_icon"></i>
        </a>
      </div>
      <!--dialog_title-->
      <div class="dialog_title">
        <i v-if="$store.state.app.view_pattern === 'mb'" class="dialog_close iconfont icon-jiantouzuo" @click="closeModule"></i>
        <span class="title" v-text="fields.popupName"></span>
        <i v-if="$store.state.app.view_pattern === 'pc'" class="dialog_close iconfont icon-chuyidong" @click="closeModule"></i>
      </div>
      <!--dialog_content-->
      <div class="dialog_content">
        <form class="my_form form-horizontal" :class="{'form-two-columns': fields.formLayout === 'twoColumns'}">
          <div class="form_item_wrap"
          v-for="(item,index) in fields.contentList"
           v-if="item.show"
          :class="{'full-width-item': item.type === 'textarea'}"
          :key="index">
            <div class="form_item">
              <h3 class="title">
                <span class="title_text" v-text="item.title"></span>
                <span class="required_icon" v-if="item.require">*</span>
              </h3>
              <!--input-->
              <input v-if="item.type == 'input'
              && item.moduleName !== 'phone'
              && item.moduleName !== 'date'"
              disabled="disabled" :placeholder="item.placeholder" class="input_style jz_focus jz_theme_focus_border_color" />
              <!-- date-->
               <div class="item_type_date content" v-if="item.moduleName =='date'">
                 <template v-if="item.dateType === 'range'">
                   <input
                    type="text"
                     disabled="disabled"
                     :placeholder="item.placeholder"
                     class="input_style jz_focus jz_theme_focus_border_color"
                   />
                   <span class="connect_icon">-</span>
                   <input
                    type="text"
                     disabled="disabled"
                     :placeholder="item.placeholder"
                     class="input_style jz_focus jz_theme_focus_border_color"
                   />
                 </template>
                 <input
                 v-else
                  type="text"
                   disabled="disabled"
                   :placeholder="item.placeholder"
                   class="input_style jz_focus jz_theme_focus_border_color"
                 />
                </div>
              <!-- phone-->
              <div v-if="item.moduleName =='phone'">
                  <div class="item_type_phone content">
                   <div class="phone_number_area">
                    <div :class="$store.state.app.view_pattern === 'pc' ? 'area_code_pc': 'area_code_mobi'" class="select_style area_code" v-if="item.areaSelect === 'true'">
                      <span v-if="$store.state.app.view_pattern === 'pc'">
                        <input readonly="readonly" value="+1" placeholder="+1" class="select_input input_style" />
                        <span class="arrow iconfont icon-jiantou pc_select_icon"></span>
                      </span>
                      <span v-else>
                        <input readonly="readonly" value="+1" placeholder="+1" class="select_input input_style" />
                        <span class="arrow iconfont icon-jiantou"></span>
                      </span>
                    </div>
                    <div class="phone_number_wrap">
                     <input maxlength="11" disabled="disabled" :placeholder="item.placeholder" class="input_style jz_focus jz_theme_focus_border_color" />
                    </div>
                   </div>
                  </div>
              </div>
              <!--radio-->
              <div class="item_type_radio content" v-if="item.type=='radio'">
                <ul class="radio_style">
                  <li class="radio_item" v-for="(option,index) in item.options" :key="index">
                    {{option.label}}
                    <span class="radio_inner jz_theme_color iconfont icon-yuanxing"></span>
                  </li>
                </ul>
              </div>
              <!--checkbox-->
              <div class="item_type_checkbox content" v-if="item.type=='checkbox'">
                <ul class="checkbox_style">
                  <li class="checkbox_item" v-for="(option,index) in item.options" :key="index">
                    {{option.label}}
                    <span class="checkbox_inner iconfont icon-fangxing jz_theme_color"></span>
                  </li>
                </ul>
              </div>
              <!--select-->
              <div class="item_type_city content" v-if="item.type=='select'">
                <div class="select_wrap pc_select">
                  <div class="select_style">
                    <input readonly="readonly" :placeholder="$t('view_dialog_index_116')" class="pc_select_input select_input input_style" />
                    <span class="arrow iconfont icon-jiantou pc_select_icon"></span>
                  </div>
                </div>
              </div>
              <!--provinces-->
              <div class="item_type_city content" v-if="item.type == 'provinces'">
                <div class="select_wrap pc_select">
                  <div class="select_style">
                    <input readonly="readonly" disabled="disabled" :placeholder="$t('view_dialog_index_116')" class="select_input input_style" />
                    <span class="arrow iconfont icon-jiantou" v-if="$store.state.app.view_pattern === 'pc'"></span>
                  </div>
                </div>
                <div class="select_wrap pc_select" v-if="$store.state.app.view_pattern === 'pc'">
                  <div class="select_style">
                    <input readonly="readonly" disabled="disabled" :placeholder="$t('view_dialog_index_116')" class="select_input input_style" />
                    <span class="arrow iconfont icon-jiantou"></span>
                  </div>
                </div>
                <div class="select_wrap pc_select" v-if="$store.state.app.view_pattern === 'pc' && item.countySelect == 'true'">
                  <div class="select_style">
                    <input readonly="readonly" disabled="disabled" :placeholder="$t('view_dialog_index_116')" class="select_input input_style" />
                    <span class="arrow iconfont icon-jiantou"></span>
                  </div>
                </div>
              </div>
              <!--textarea-->
              <div class="item_type_textarea content" v-if="item.type == 'textarea'">
                <textarea disabled="disabled" maxlength="1000" placeholder="" class="textarea_style jz_focus jz_theme_focus_border_color"></textarea>
              </div>
            </div>
          </div>
          <!--verify-->
          <div class="form_item_wrap fixed_item formitem_validateCode" 
          v-if="fields.verifyCodeShow 
          || typeof fields.verifyCodeShow == 'undefined'">
            <div class="form_item">
              <div class="item_type_validateCode content">
                <input :placeholder="getLang($t('view_login_index_47'))" maxlength="4" disabled="disabled" class="validateCode_input input_style jz_focus jz_theme_focus_border_color" />
                <img alt=" " src="/static/image/verify.png" class="validateCode_img" />
              </div>
            </div>
          </div>
          <!--button-->
          <div class="form_item_wrap fixed_item formitem_submit">
            <div class="form_item">
              <button :style="buttonStyle" class="form_submit content jz_theme_bg_color" type="button" @click="submitForm" v-text="fields.buttonName"></button>
            </div>
          </div>
        </form>
      </div>
      <div class="popup_save_wrap" v-if="!tool_tab_isShow">
        <el-button class="btn_save" size="small" @click="saveEvent" :disabled="isDisabled">{{$t('components_set_link_components_submit_form_index_2469')}}</el-button>
        <el-button class="btn_cancel" size="small" @click="cancelEvent">{{$t('view_public_topbar_14')}}</el-button>
      </div>
    </div>
  </div>
</template>
<script>
import i18n from '../../../../language/index'

  import { saveForm } from '@/api/app';

  export default {
    name: 'submit_form_index',
    data() {
      return {
        tool_tab_isShow: true,
        isDisabled: true,
        isFirst: true,
        isFirst_: true
      };
    },
    computed: {
      fields () {
        let fields = this.$store.state.app.form.fields || {
          buttonName: '',
          popupName: '',
          formLayout: 'oneColumn'
        }
        if(typeof fields == 'string') {
          fields = JSON.parse(fields)
        }
        return fields
      },
      buttonStyle () {
        return {
          backgroundColor: this.$store.state.myRender.common.theme_color
        }
      },
    },
    watch: {
      'fields.popupName'(val) {
        if(this.isFirst){
          this.isFirst = false
          return false
        }
        this.isDisabled = false
      },
      'fields.buttonName'(val) {
        if(this.isFirst_){
          this.isFirst_ = false
          return false
        }
        this.isDisabled = false
      },
      'fields.formLayout'(val) {
        if(this.isFirst){
          this.isFirst = false
          return false
        }
        this.isDisabled = false
      },
    },
    methods:{
      submitForm() {
         this.$message({showClose: true,message: i18n.t('components_set_link_components_submit_form_index_2470')});
      },
      closeModule() {
        this.$store.commit('app/set_submit_form_isShow', false);
        this.templet.main_dialog_reset()
      },
      openEditFormDialog() {
        this.tool_tab_isShow = false
        this.$store.commit('app/set_main_dialog_close_IsShow',false)
        this.$store.commit('main_dialog/Change_main_dialog_isShow', true);
        this.$store.commit('main_dialog/Change_edit_name', 'submit_form');
      },
      cancelEvent(){
        this.tool_tab_isShow = true
        this.$store.commit('app/set_main_dialog_close_IsShow',true)
        this.$store.commit('main_dialog/Change_main_dialog_isShow',false);
      },
      // 保存表单
      saveFormData() {
        let form = {
          title: this.$store.state.app.form.title,
          fields: JSON.stringify(this.fields),
          id: this.$store.state.app.form.id
        }
        this.templet.addForm(form);
      },
      saveEvent() {
        this.tool_tab_isShow = true
        this.isDisabled = true
        this.$store.commit('app/set_main_dialog_close_IsShow',true)
        this.$store.commit('main_dialog/Change_main_dialog_isShow',false);
        this.saveFormData()
      }
    },
    components:{
    },
    mounted(){
    }
  }
</script>

<style scoped lang="scss">
.popup_save_wrap {
  /deep/ .el-button {
    margin: 0 18px;
    display: inline-block;
    position: relative;
    box-sizing: border-box;
    height: 34px;
    padding: 0 28px;
    border: 1px solid #e3e2e8;
    user-select: none;
    border-radius: 2px;
    background-color: #fff;
    outline: 0;
    font-size: 13px;
    font-weight: 400;
    line-height: 0;
    white-space: nowrap;
  }
}

// 一行两列布局
.form-two-columns {
  display: flex;
  flex-wrap: wrap;

  /deep/ .form_item_wrap {
    width: 50%;
    box-sizing: border-box;
    padding-right: 10px;

    &:nth-child(2n) {
      padding-right: 0;
      padding-left: 10px;
    }

    // textarea 独占一行
    &.full-width-item {
      width: 100%;
      padding-right: 0;
      padding-left: 0;
    }

    // 验证码独占一行
    &.formitem_validateCode {
      width: 100%;
      padding-right: 0;
      padding-left: 0;
    }

    // 提交按钮在两列中，但需要对齐
    &.formitem_submit {
      // 添加 title 的高度作为上边距，以对齐其他表单项
      .form_item {
        padding-top: 32px; // title 的高度约为 32px
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/set_link/components/submit_form/index.vue